module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-redis-02-m.9b0ac12c7e0ccb82a415291a4449bdf0.png";